import React from "react";
import PropTypes from "prop-types";

const AdminOnlyWarning = ({
	singular = false,
	userCanEditSettings,
	message,
}) => {
	// If user can edit settings, don't show the warning
	if (userCanEditSettings) {
		return null;
	}

	return (
		<div
			style={{
				marginBottom: 20,
				padding: 10,
				backgroundColor: "#fff3cd",
				border: "1px solid #ffeaa7",
				borderRadius: 4,
				color: "#856404",
			}}
		>
			{message
				? message
				: `You do not have the ${singular ? "Right" : "Rights"} to edit ${singular ? "this setting" : "these settings"}`}
		</div>
	);
};

const LexWorkplaceAdminOnlyWarning = ({ singular = false }) => {
	return (
		<div
			style={{
				marginBottom: 20,
				padding: 10,
				backgroundColor: "#fff3cd",
				border: "1px solid #ffeaa7",
				borderRadius: 4,
				color: "#856404",
			}}
		>
			{`Please contact LexWorkplace Support for information on changing ${singular ? "this setting" : "these settings"}`}
		</div>
	);
};

AdminOnlyWarning.propTypes = {
	singular: PropTypes.bool,
	userCanEditSettings: PropTypes.bool.isRequired,
	message: PropTypes.string,
};

export default AdminOnlyWarning;
export { LexWorkplaceAdminOnlyWarning };
